import { RouteConfig } from 'vue-router';
import FreeDownloads from './free-downloads.vue';

const route:RouteConfig = {
  path: 'freedownloads',
  component: FreeDownloads,
};

export function getDefaultParams() {
  return {};
}

export default route;
